import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { SEGMENT_METRIC_FILTER_MAP } from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/OverlapSteam/constants';

// page_name(played/wishlisted) -> 默认 4-segment key 映射
export const PAGE_NAME_TO_DEFAULT_SEGMENT: Record<string, string> = {
  played: 'played_play',
  wishlisted: 'wishlisted_play',
};

// 根据 segment key 获取 REVENUE_GROWTH 的默认值
const getSegmentRevenueGrowthDefault = (segmentKey: string) => {
  const [metricFilter] = SEGMENT_METRIC_FILTER_MAP[segmentKey] || [];
  return {
    opt: metricFilter?.opt || '>',
    value: metricFilter?.value ?? 20,
  };
};

// 筛选器value默认值 
// 复制舆情代码
export const getDefaultFilterValue = (defaultPage?: string) => {
  const pageName = defaultPage ?? 'played';
  const segmentKey = PAGE_NAME_TO_DEFAULT_SEGMENT[pageName] || 'played_play';
  return {
    [filterKeyMap.OVERLAPSTEAM_PLAYERS]: {
      value: segmentKey,
    },
    [filterKeyMap.ENGAGELEVEL_SEGEMENT_TWO]: {
      value: {
        engagementLevelA: '2h',
        engagementLevelB: '2h',
      },
    },
    [filterKeyMap.REGION_SEGMENT]: {
      value: 'global',
    },
    // REVENUE_GROWTH: 筛选器 UI 渲染和 handleFilterToApiParams 都读这个 key
    [filterKeyMap.REVENUE_GROWTH]: {
      value: getSegmentRevenueGrowthDefault(segmentKey),
    },
    [filterKeyMap.REVENUE_GROWTH_TWO]: {
      value: {
        revenueGrowthPP: { opt: '>', value: 20 },
        revenueGrowthPW: { opt: '>', value: 4 },
        revenueGrowthWP: { opt: '>', value: 20 },
        revenueGrowthWW: { opt: '>', value: 20 },
        segmentName: pageName,
      },
    },
    [filterKeyMap.ENGAGELEVEL_SEGEMENT]: {
      value: '2h',
    },
    [filterKeyMap.STEAM_TAGS]: {
      value: [],
      logic: 'AND',
    },
  };
};
